function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import moment from "moment";
import "moment/locale/es";
import UserPermissions from "./UserPermissions";

var UserDetail = function UserDetail(props) {
  var adminJson = props.admin,
      token = props.token,
      translationsJson = props.translations;
  var admin = JSON.parse(adminJson);
  var translations = translationsJson ? JSON.parse(translationsJson) : {
    role: "Rol",
    super_admin: "Super Admin",
    administrator: "Ejecutivo",
    details: "Detalles",
    permissions: "Permisos",
    administrator_data: "Datos del Ejecutivo",
    created_at: "Fecha Creación",
    updated_at: "Última Actualización",
    full_name: "Nombre Completo",
    rut: "RUT",
    position: "Cargo",
    contract_start_date: "Inicio Contrato",
    contract_end_date: "Fin Contrato",
    contract_type: "Tipo de Contrato",
    birthdate: "Fecha Nacimiento",
    age: "Edad",
    phone: "Teléfono",
    email: "Email",
    life_commission: "Comisión Vida",
    general_commission_percentage: "Comisión Generales (%)",
    renewal_commission: "Comisión Renovación",
    calculated_life_commission: "Comisión Vida (Calculada)",
    calculated_general_commission_percentage: "Comisión Generales % (Calculada)",
    calculated_renewal_commission: "Comisión Renovación (Calculada)",
    comments: "Comentarios"
  };

  var _React$useState = React.useState("details"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeSection = _React$useState2[0],
      setActiveSection = _React$useState2[1];

  var formatDate = function formatDate(date) {
    if (!date) return "-";
    return moment(date).format("DD/MM/YYYY");
  };

  var getAge = function getAge(birthdate, calculatedAge) {
    // Si hay una edad calculada del servidor, usarla
    if (calculatedAge !== null && calculatedAge !== undefined) {
      return "".concat(calculatedAge, " a\xF1os");
    } // Si no, calcular desde birthdate


    if (!birthdate) return "-";
    var age = moment().diff(moment(birthdate), "years");
    return "".concat(age, " a\xF1os");
  };

  var formatNumber = function formatNumber(value) {
    if (value === null || value === undefined) return "-";
    return value.toString().replace(/\./g, ",");
  };

  var renderDetails = function renderDetails() {
    var getRoleLabel = function getRoleLabel() {
      return admin.is_super_admin ? translations.super_admin : translations.administrator;
    };

    return /*#__PURE__*/React.createElement("div", {
      className: "card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, translations.administrator_data))), /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-6"
    }, /*#__PURE__*/React.createElement("table", {
      className: "table table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      style: {
        width: "40%"
      }
    }, translations.created_at), /*#__PURE__*/React.createElement("td", null, formatDate(admin.created_at))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.role), /*#__PURE__*/React.createElement("td", null, getRoleLabel())), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.full_name), /*#__PURE__*/React.createElement("td", null, admin.full_name || admin.calculated_full_name || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.rut), /*#__PURE__*/React.createElement("td", null, admin.rut || admin.calculated_rut || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.position), /*#__PURE__*/React.createElement("td", null, admin.position || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.contract_start_date), /*#__PURE__*/React.createElement("td", null, formatDate(admin.contract_start_date))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.contract_end_date), /*#__PURE__*/React.createElement("td", null, formatDate(admin.contract_end_date))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.contract_type), /*#__PURE__*/React.createElement("td", null, admin.contract_type || "-"))))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-6"
    }, /*#__PURE__*/React.createElement("table", {
      className: "table table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      style: {
        width: "40%"
      }
    }, translations.updated_at), /*#__PURE__*/React.createElement("td", null, formatDate(admin.updated_at))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.birthdate), /*#__PURE__*/React.createElement("td", null, formatDate(admin.birthdate))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.age), /*#__PURE__*/React.createElement("td", null, admin.birthdate || admin.age !== null && admin.age !== undefined ? getAge(admin.birthdate || "", admin.age) : "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.phone), /*#__PURE__*/React.createElement("td", null, admin.phone || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.email), /*#__PURE__*/React.createElement("td", null, admin.email)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.life_commission), /*#__PURE__*/React.createElement("td", null, admin.life_commission !== null && admin.life_commission !== undefined ? formatNumber(admin.life_commission) : admin.calculated_life_commission !== null && admin.calculated_life_commission !== undefined ? "".concat(formatNumber(admin.calculated_life_commission), "%") : "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.general_commission_percentage), /*#__PURE__*/React.createElement("td", null, admin.general_commission_percentage !== null && admin.general_commission_percentage !== undefined ? "".concat(formatNumber(admin.general_commission_percentage), "%") : admin.calculated_general_commission_percentage !== null && admin.calculated_general_commission_percentage !== undefined ? "".concat(formatNumber(admin.calculated_general_commission_percentage), "%") : "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translations.renewal_commission), /*#__PURE__*/React.createElement("td", null, admin.renewal_commission !== null && admin.renewal_commission !== undefined ? formatNumber(admin.renewal_commission) : admin.calculated_renewal_commission !== null && admin.calculated_renewal_commission !== undefined ? "".concat(formatNumber(admin.calculated_renewal_commission), "%") : "-")))))), admin.comments && /*#__PURE__*/React.createElement("div", {
      className: "row",
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("table", {
      className: "table table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      style: {
        width: "20%"
      }
    }, translations.comments), /*#__PURE__*/React.createElement("td", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, admin.comments))))))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "user-detail-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs",
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("li", {
    className: activeSection === "details" ? "active" : ""
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setActiveSection("details");
    }
  }, translations.details)), /*#__PURE__*/React.createElement("li", {
    className: activeSection === "permissions" ? "active" : ""
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setActiveSection("permissions");
    }
  }, translations.permissions))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, activeSection === "details" && renderDetails(), activeSection === "permissions" && /*#__PURE__*/React.createElement(UserPermissions, {
    admin: admin,
    token: token
  }))));
};

export default UserDetail;